import { FC, useState } from "react";

import IAssistitoProps from "pages/Prenotazione/Form/Assistito/IAssititoProps";
import { IAssistito, IFamiliare } from "core/interfaces/data/IAssistitoRequest";

import Crea from "./FormAssistito/FormAssistito";
import ScegliAssistito from "./ScegliAssistito/ScegliAssistito";
import { IRegisterData, IRegisteredUserData } from "core/interfaces/data/IRegisterRequest";
import i18n from "utils/i18n";
import AssistitoRepository from "core/data/AssistitoRepository";
import { resetRegisterData, setDestinatarioAssistenza, setRegisterData } from "core/redux/features/dataForm/dataFormSlice";
import { getReduxRegisterData } from "utils/ReduxUtils";
import FormUtente from "./FormUtente/FormUtente";
import "./Assistito.css";
import { Enhanced } from "utils/ReactUtils";

const Assistito: FC<IAssistitoProps> = ({ OnSubmit, BackToRegisterPage, sessionInfo, dispatch, dataForm }) => {
	const [create, setCreate] = useState<boolean>(!sessionInfo.isLogged);
	const [userCreated, setUserCreated] = useState<boolean>(sessionInfo.isLogged || dataForm.registerData !== undefined);

	const [perFamiliare, setPerFamiliare] = useState(dataForm.registerData?.PerFamiliare!);

	const OnSubmitRegister = (registerData: IRegisterData) => {
		dispatch(setRegisterData(getReduxRegisterData(registerData)));
		setUserCreated(true);
		setPerFamiliare(registerData.PerFamiliare);
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	};

	const OnClickInserisciFamiliare = () => {
		dispatch(setDestinatarioAssistenza(undefined));
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
		setPerFamiliare(true);
		setCreate(true);
	};

	const OnSubmitCrea = async (data: IAssistito) => {
		let loginData: IRegisteredUserData | undefined;

		if (sessionInfo.isLogged && !perFamiliare) {
			try {
				loginData = await AssistitoRepository.GetLoggedUserData({
					IdSessione: sessionInfo.sessione!.idSessione,
					culture: i18n.language,
					step: sessionInfo.step as number,
				});
			} catch (err: any) {
				// setIsError(true);
				console.log(err);
			}
		} else if (dataForm.registerData) {
			loginData = {
				Nome: dataForm.registerData!.Nome,
				Cognome: dataForm.registerData!.Cognome,
				CodiceFiscale: dataForm.registerData!.CodiceFiscale,
				TelefonoContatti: dataForm.registerData!.TelefonoContatti,
				Email: dataForm.registerData!.Email,
				Sesso: dataForm.registerData!.Sesso,
				DataNascita: dataForm.registerData!.DataNascita.toLocaleString(), //qui modifica su struttura dati da dare in pasto a redux, prima era un moment $ALC
				// DataNascita: dataForm.registerData!.DataNascita, //qui modifica su struttura dati da dare in pasto a redux, prima era un moment $ALC
				ComuneNascita: dataForm.registerData!.ComuneNascita,
				IdCittadinanza: dataForm.registerData!.Cittadinanza.ID,
				ConsensoSMS: dataForm.registerData!.ConsensoSMS,
				ConsensoMail: dataForm.registerData!.ConsensoMail,
			};
		}

		if (loginData !== undefined) {
			//questo era assente nelle ultime??
			data.Nome = data.Nome || loginData!.Nome;
			data.Cognome = data.Cognome || loginData!.Cognome;
			data.CodiceFiscale = data.CodiceFiscale || loginData!.CodiceFiscale;
			data.Sesso = data.Sesso || loginData!.Sesso;
			data.DataNascita = data.DataNascita || loginData!.DataNascita;
			data.ComuneNascita = data.ComuneNascita || loginData!.ComuneNascita;
			data.IdCittadinanza = data.IdCittadinanza || loginData!.IdCittadinanza;
			// se sto creando l'account allora inserisco anche il telefono dei contatti altrimenti no
			if (!sessionInfo.isLogged) data.TelefonoContatti = data.TelefonoContatti || loginData!.TelefonoContatti.toString();
		}

		OnSubmit(data, true);
	};
	const OnClickInserisciRichiedente = () => {
		setPerFamiliare(false);
		setCreate(true);
	};

	const Back = () => {
		if (sessionInfo.isLogged) {
			// ritorna alla lista dei familiari
			setCreate(false);
		} else {
			setUserCreated(false);
		}
	};

	const ChangeAuthenticationMode = () => {
		dispatch(resetRegisterData());
		// ritorna alla pagina di auth
		BackToRegisterPage();
	};

	if (create) {
		return (
			<>
				{!sessionInfo.isLogged && !userCreated ? (
					<FormUtente OnSubmit={OnSubmitRegister} ChangeAuthenticationMode={ChangeAuthenticationMode} />
				) : (
					<Crea perFamiliare={perFamiliare} OnSubmit={OnSubmitCrea} Back={Back} />
				)}
			</>
		);
	} else {
		return (
			<>
				<ScegliAssistito
					OnSubmitFamiliareEsistente={(data: IFamiliare) => {
						OnSubmit(data, false);
					}}
					OnClickInserisciFamiliare={OnClickInserisciFamiliare}
					OnClickInserisciRichiedente={OnClickInserisciRichiedente}
				/>
			</>
		);
	}
};

export default Enhanced(Assistito, {});
